<template>
  <div class="card-wrapper">
    <div class="card mb-4">
      <div class="card-header">
        <h3 class="mb-0">{{ title }}</h3>
      </div>

      <loading-panel v-if="isLoading" />

      <div v-else class="card-body">
        <div v-if="!isLoading && data">
          <slot></slot>
        </div>

        <span v-if="error" class="text-danger">No se pudieron cargar los datos</span>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingPanel from '../LoadingPanel';
import RestResource from '../../services/rest.service';

export default {
  components: {
    LoadingPanel,
  },

  props: {
    title: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isLoading: false,
      data: null,
      error: null,
    };
  },

  methods: {
    async resolve(promise) {
      this.isLoading = true;
      const [data, error] = await RestResource.resolve(promise);

      this.data = data;
      this.error = error;

      this.isLoading = false;

      return data ? data.data : {};
    },
  },
};
</script>
